<!-- src/app/widget/pages/tour/tour.component.html -->
<section class="tour-page cbw-tour-page">
  @if (loading()) {
    <app-loader />
  } @else if (loadError()) {
    <app-new-alert
      [subTitle]="loadError()! | translate"
      type="danger"
      customClass="mt-3 mb-3"
      role="alert"
      aria-live="polite"
    />
  } @else {
    @if (supportedWidgetLanguages()?.length > 1 && langSwitcher()) {
      <div class="tour-page__lang-row">
        <div ngbDropdown placement="bottom-right" class="lang-dropdown-wrapper cbcw-lang-dropdown-wrapper">
          <button class="nav-link lang-dropdown" id="tour-lang-dropdown" ngbDropdownToggle aria-label="Select language" [attr.aria-haspopup]="true" [attr.aria-expanded]="false">
            <span>
              @for (language of languages; track language) {
                @if (lang === language.locale) {
                  <img width="20px" height="20px" alt="{{ language.text }}" src="{{ deployUrl + language.flagIcon }}" />
                }
              }
            </span>
          </button>
          <div class="lang-dropdown-menu" ngbDropdownMenu aria-labelledby="tour-lang-dropdown" role="listbox">
            @for (language of languages; track language) {
              @if (lang !== language.locale && supportedWidgetLanguages().indexOf(language.value) > -1) {
                <a ngbDropdownItem class="lang-dropdown-menu-item" href="javascript:void(0)" (click)="switchLanguage(language.locale)" role="option" [attr.aria-selected]="false">
                  <span class="d-flex justify-content-center">
                    <img width="20px" height="20px" alt="{{ language.text }}" src="{{ deployUrl + language.flagIcon }}" />
                  </span>
                </a>
              }
            }
          </div>
        </div>
      </div>
    }

    <header class="tour-page__header cbw-tour-header">
      @if (titleTemplate) {
        <h2 [innerHTML]="(titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"></h2>
      }
      @if (subtitleTemplate) {
        <p [innerHTML]="(subtitleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"></p>
      }
    </header>

    <div class="tour-page__body cbw-tour-body">
      <div class="tour-page__main cbw-tour-main">
        <app-tour-service-list
          [groups]="groups()"
          [selectedIds]="selectedIdSet()"
          [disabledIds]="disabledIds()"
          [plantTravelPills]="plantTravelPills()"
          [widgetTemplates]="widgetTemplates()"
          [lang]="lang"
          (toggleService)="onToggleService($event)"
          (viewAbsences)="onViewAbsences($event)"
        />
      </div>

      <div class="tour-page__sidebar cbw-tour-sidebar">
        <app-tour-time-overview
          [selectedServices]="selectedServices()"
          [travelMap]="travelMap()"
          [visitMinutes]="visitMinutes()"
          [travelMinutes]="travelMinutes()"
          [totalMinutes]="totalMinutes()"
          [maxMinutes]="maxDurationMinutes()"
          [exceedsMax]="exceedsMax()"
          [canBookTour]="canBookTour()"
          [preparing]="preparing()"
          [errorMessageKey]="errorMessageKey()"
          (bookTour)="onBookTour()"
        />
      </div>
    </div>
  }
</section>
